
import useLocale from "@/core/common/useLocale";

export default {
  name: "consent-check",

  props: {
    index: {
      type: Number,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    checked: {
      default: false,
    },
  },

  emits: ["change"],

  setup(props, { emit }) {
    const { t } = useLocale();

    const handleSwitch = function () {
      emit("change", { index: props.index, value: !props.checked });
    };

    return {
      t,
      handleSwitch,
    };
  },
};
